import { DeliveryAreaPage } from "./DeliveryAreaPage";

export const DeliveryAreaPane = () => {
  return <DeliveryAreaPage />;
};
